import pkg from '../package.json'
import { initializeApplication } from '@artup/client'
import { useCommonApplet } from '@artup/common-ui'
import { useAccountsApplet } from '../src/applet'
import Applet from '../src/applet.vue'
import './index.scss'


window.addEventListener('load', async () => {
  const configuration = window.artupConfiguration

  await initializeApplication(pkg, {
    component: Applet,
    container: '#applet',
    applets: [
      useCommonApplet,
      useAccountsApplet
    ],
    routes: {
      home: '/accounts',
      login: '/accounts/login'
    },
    plugins: [],
    configuration
  })
})
